import styled from 'styled-components';
import { Button } from '@material-ui/core';

const OptionButton = styled(Button)`
  border: 2px solid black;
  background-color: ${({ selected = false }) => (selected ? 'black' : 'white')};
  color: ${({ selected = false }) => (selected ? 'white' : 'black')};
  margin-right: 0.5em;
  transition: background-color 0.3s ease, color 0.3s ease, border 0.3s ease;

  &:hover {
    border: 2px solid black;
    background-color: black;
    color: white;
  }

  &:last-child {
    margin-right: 0;
  }
`;

export default OptionButton;
